import { useCallback } from 'react';

import { type ChannelListResponse, ChannelListResponseSchema } from '../../../api';
import { useApiClient } from '../../../lib/api/api-context';
import { type ApiQueryResult, useApiQuery } from '../../../lib/api/use-api-query';

/**
 * `GET /channels` for E3 (S5 R1), parsed with the contract schema. Not polled (master X8 polls
 * `/me` and `/positions` only): "refresh", Retry and a write conflict call `refetch`.
 */
export function useChannels(): ApiQueryResult<ChannelListResponse> {
  const api = useApiClient();
  const load = useCallback(
    (signal: AbortSignal) => api.get('/channels', ChannelListResponseSchema, signal),
    [api],
  );
  return useApiQuery(load);
}
